export default __webpack_public_path__ + "static/media/Punto_10_Chiesa_degli_Olandesi_ENG_Def.d7a99233.aac";